/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */
import "../style.scss";
import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  Button,
  Space,
  Input,
  message,
  Tooltip,
  Popconfirm,
  Spin,
  DatePicker,
  Card,
  Select,
  Modal,
  Row,
  Col,
  Tag,
  Form,
} from "antd";
import API from "../../../api";
import urls from "../../../api/urls";
import { SearchOutlined } from "@ant-design/icons";

const { DELIVERY_PARTNER_LIST, HUBS_LIST } = urls;

const DeliveryPartnerList = ({ type }) => {
  const [deliveryPartnerList, setDeliveryPartnerList] = useState([]);
  const [selectedDeliveryPartner, setSelectedDeliveryPartner] = useState(null);
  const [hubList, setHubList] = useState([]);
  const [selectedHub, setSelectedHub] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentHub, setCurrentHub] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [hubSearchText, setHubSearchText] = useState("");
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [bulkUpdateMode, setBulkUpdateMode] = useState(false);
  const [selectedPartners, setSelectedPartners] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [createForm] = Form.useForm();
  const [createLoading, setCreateLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    state: "",
    email: "",
    dpType: [type],
    pincode: "",
    dpHubId: null,
    contactPersonPhone: "",
    contactPersonName: "",
    role: "ROLE_DPOPERATOR",
  });

  const getDeliveryPartnerList = async (page = 1, limit = 10) => {
    try {
      setLoading(true);
      let result = await API.Api(
        `${DELIVERY_PARTNER_LIST}?page=${page}&limit=${limit}&dpType=${type}`
      ).get();
      let response = result?.response?.data;
      if (response?.status === 200) {
        setDeliveryPartnerList(response?.data || []);
        setPagination({
          ...pagination,
          current: page,
          pageSize: limit,
          total: response?.count || 0,
        });
      }
    } catch (error) {
      message.error("Failed to fetch delivery partners");
    } finally {
      setLoading(false);
    }
  };

  const getAllHubs = async () => {
    try {
      setLoading(true);
      let result = await API.Api(`${HUBS_LIST}?limit=500`).get();
      let response = result?.response?.data?.data;
      setHubList(response || []);
    } catch (error) {
      message.error("Failed to fetch hub data");
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (newPagination) => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });
    getDeliveryPartnerList(newPagination.current, newPagination.pageSize);
  };

  useEffect(() => {
    getDeliveryPartnerList(pagination.current, pagination.pageSize);
    getAllHubs();
  }, [pagination.current, pagination.pageSize]);

  const handleDeliveryPartnerChange = async (value) => {
    setSelectedDeliveryPartner(value);
    await getAllHubs();
    const selectedDP = deliveryPartnerList.find((dp) => dp.dpId === value);
    if (selectedDP) {
      setCurrentHub(selectedDP.dpHubId);
      setSelectedHub(selectedDP.dpHubId);
    }
  };

  const handleHubChange = (value) => {
    setSelectedHub(value);
  };

  const handleUpdate = async () => {
    if (!selectedDeliveryPartner || !selectedHub) {
      message.error("Please select both Delivery Partner and Hub");
      return;
    }

    try {
      setLoading(true);
      const payload = {
        dpId: selectedDeliveryPartner,
        premiseId: selectedHub,
      };
      await API.Api(`${urls.UPDATE_DELIVERY_PARTNER_HUB}`).patch(payload);

      await Promise.all([getDeliveryPartnerList(), getAllHubs()]);

      const updatedDP = deliveryPartnerList.find(
        (dp) => dp.dpId === selectedDeliveryPartner
      );
      if (updatedDP) {
        setCurrentHub(updatedDP.dpHubId);
        setSelectedHub(updatedDP.dpHubId);
      }

      message.success("Delivery Partner hub updated successfully");
      setShowUpdateModal(false);
    } catch (error) {
      message.error("Failed to update delivery partner hub");
    } finally {
      setLoading(false);
    }
  };

  const handleBulkUpdate = async () => {
    if (!selectedHub || selectedPartners.length === 0) {
      message.error("Please select both Hub and at least one Delivery Partner");
      return;
    }

    try {
      setLoading(true);
      const updatePromises = selectedPartners.map((dpId) =>
        API.Api(`${urls.UPDATE_DELIVERY_PARTNER_HUB}`).patch({
          dpId,
          premiseId: selectedHub,
        })
      );

      await Promise.all(updatePromises);
      await Promise.all([getDeliveryPartnerList(), getAllHubs()]);

      message.success("Bulk update completed successfully");
      setBulkUpdateMode(false);
      setSelectedPartners([]);
    } catch (error) {
      message.error("Failed to perform bulk update");
    } finally {
      setLoading(false);
    }
  };

  const handleCreateDeliveryPartner = async (values) => {
    try {
      setCreateLoading(true);
      const payload = {
        ...values,
        firstName: values.firstName.toUpperCase(),
        lastName: values.lastName.toUpperCase(),
        state: values.state.toUpperCase(),
        city: values.city.toUpperCase(),
        pincode: parseInt(values.pincode),
        dpType: [type],
        role: "ROLE_DPOPERATOR",
      };

      const response = await API.Api(`${urls.CREATE_DELIVERY_PARTNER}`).post(
        payload
      );

      if (
        response?.response?.data?.status === 200 ||
        response?.response?.data?.status === 201
      ) {
        message.success("Delivery Partner created successfully");
        setShowCreateModal(false);
        createForm.resetFields();
        getDeliveryPartnerList();
      } else {
        message.error(
          response?.response?.data?.message ||
            "Failed to create delivery partner"
        );
      }
    } catch (error) {
      console.log(error);
      message.error("Failed to create delivery partner");
    } finally {
      setCreateLoading(false);
    }
  };

  const columns = [
    {
      key: "serialNumber",
      title: "S.No",
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
      width: 80,
      fixed: "left",
    },
    {
      title: "Delivery Partner Name",
      dataIndex: "dpName",
      key: "dpName",
      sorter: (a, b) => a.dpName.localeCompare(b.dpName),
      width: 250,
    },
    {
      title: "Delivery Partner ID",
      dataIndex: "dpId",
      key: "dpId",
      sorter: (a, b) => a.dpId - b.dpId,
      width: 120,
    },
    {
      title: "Current Hub",
      dataIndex: "dpHubId",
      key: "dpHubId",
      render: (hubId) => {
        const hub = hubList.find((h) => h.premiseId === hubId);
        return hub ? hub.hubName : "-";
      },
      width: 200,
    },
    {
      title: "Business Type",
      dataIndex: "dpType",
      key: "dpType",
      render: (types) => (
        <Space>
          {types?.map((type) => {
            let color = "blue"; // default color
            switch (type) {
              case "CARGO":
                color = "red";
                break;
              case "HYPERLOCAL":
                color = "pink";
                break;
              case "COURIER":
                color = "green";
                break;
              case "ECOMM":
                color = "blue";
                break;
              default:
                color = "blue";
            }
            return (
              <Tag color={color} key={type}>
                {type}
              </Tag>
            );
          })}
        </Space>
      ),
      width: 200,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="link"
          onClick={() => {
            setSelectedDeliveryPartner(record.dpId);
            setSelectedHub(record.dpHubId);
            setShowUpdateModal(true);
          }}
        >
          Update Hub
        </Button>
      ),
      width: 120,
      fixed: "right",
    },
  ];

  const filteredDeliveryPartners = deliveryPartnerList.filter(
    (dp) =>
      dp.dpName.toLowerCase().includes(searchText.toLowerCase()) ||
      dp.dpId.toString().includes(searchText)
  );

  const filteredHubs = hubList.filter(
    (hub) =>
      hub.hubName.toLowerCase().includes(hubSearchText.toLowerCase()) ||
      hub.premiseId.toString().includes(hubSearchText)
  );

  return (
    <div className="master-main-container m-1 mt-3 p-1">
      <div className="row">
        <b className="master-title">Delivery Partner Management</b>
        <Button
          type="primary"
          onClick={() => setShowCreateModal(true)}
          style={{ float: "right", marginRight: "16px" }}
        >
          Create Delivery Partner
        </Button>
      </div>

      <Row gutter={16} className="mt-3">
        <Col span={24}>
          <Card>
            <Row gutter={16} className="mb-3">
              <Col span={8}>
                <Input
                  placeholder="Search Delivery Partners"
                  prefix={<SearchOutlined />}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  allowClear
                />
              </Col>
              <Col span={8}>
                <Input
                  placeholder="Search Hubs"
                  prefix={<SearchOutlined />}
                  value={hubSearchText}
                  onChange={(e) => setHubSearchText(e.target.value)}
                  allowClear
                />
              </Col>
              <Col span={8}>
                <Button
                  type="primary"
                  onClick={() => setBulkUpdateMode(!bulkUpdateMode)}
                >
                  {bulkUpdateMode ? "Exit Bulk Update" : "Bulk Update Mode"}
                </Button>
              </Col>
            </Row>

            {bulkUpdateMode && (
              <Row gutter={16} className="mb-3">
                <Col span={12}>
                  <Select
                    className="w-100"
                    placeholder="Select Hub"
                    value={selectedHub}
                    onChange={handleHubChange}
                    loading={loading}
                    showSearch
                    filterOption={(input, option) =>
                      option.label.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    }
                    options={filteredHubs.map((hub) => ({
                      label: hub.hubName,
                      value: hub.premiseId,
                    }))}
                  />
                </Col>
                <Col span={12}>
                  <Button
                    type="primary"
                    onClick={handleBulkUpdate}
                    disabled={!selectedHub || selectedPartners.length === 0}
                  >
                    Update Selected Partners
                  </Button>
                </Col>
              </Row>
            )}

            <Table
              columns={columns}
              dataSource={filteredDeliveryPartners}
              rowKey="dpId"
              loading={loading}
              rowSelection={
                bulkUpdateMode
                  ? {
                      selectedRowKeys: selectedPartners,
                      onChange: (selectedRowKeys) =>
                        setSelectedPartners(selectedRowKeys),
                    }
                  : null
              }
              pagination={{
                ...pagination,
                showSizeChanger: true,
                showQuickJumper: true,
              }}
              onChange={handleTableChange}
            />
          </Card>
        </Col>
      </Row>

      <Modal
        title="Update Delivery Partner Hub"
        open={showUpdateModal}
        onCancel={() => setShowUpdateModal(false)}
        footer={[
          <Button key="cancel" onClick={() => setShowUpdateModal(false)}>
            Cancel
          </Button>,
          <Button
            key="update"
            type="primary"
            onClick={handleUpdate}
            loading={loading}
          >
            Update
          </Button>,
        ]}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Select
              className="w-100 mb-3"
              placeholder="Select Hub"
              value={selectedHub}
              onChange={handleHubChange}
              loading={loading}
              showSearch
              filterOption={(input, option) =>
                option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              options={filteredHubs.map((hub) => ({
                label: hub.hubName,
                value: hub.premiseId,
                style:
                  hub.premiseId === currentHub
                    ? { fontWeight: "bold", color: "#1890ff" }
                    : {},
              }))}
            />
          </Col>
        </Row>
      </Modal>

      <Modal
        title="Create Delivery Partner"
        open={showCreateModal}
        onCancel={() => {
          setShowCreateModal(false);
          createForm.resetFields();
        }}
        footer={null}
        width={800}
      >
        <Form
          form={createForm}
          layout="vertical"
          onFinish={handleCreateDeliveryPartner}
          initialValues={formData}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="firstName"
                label="First Name"
                rules={[{ required: true, message: "Please enter first name" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="lastName"
                label="Last Name"
                rules={[{ required: true, message: "Please enter last name" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="address"
                label="Address"
                rules={[{ required: true, message: "Please enter address" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="city"
                label="City"
                rules={[{ required: true, message: "Please enter city" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="state"
                label="State"
                rules={[{ required: true, message: "Please enter state" }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="contactPersonName"
                label="Contact Person Name"
                rules={[
                  {
                    required: true,
                    message: "Please enter contact person name",
                  },
                  {
                    pattern: /^[A-Za-z\s]*$/,
                    message: "Please enter only letters and spaces",
                  }
                ]}
              >
                <Input 
                  onKeyPress={(e) => {
                    if (!/[A-Za-z\s]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="contactPersonPhone"
                label="Contact Person Phone"
                rules={[
                  {
                    required: true,
                    message: "Please enter contact person phone number",
                  },
                  { pattern: /^[0-9]*$/, message: "Please enter numbers only" },
                ]}
              >
                <Input
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  maxLength={10}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="pincode"
                label="Pincode"
                rules={[{ required: true, message: "Please enter pincode" }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: "Please enter email" },
                  { type: "email", message: "Please enter a valid email" },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="dpHubId"
                label="Hub"
                rules={[{ required: true, message: "Please select a hub" }]}
              >
                <Select
                  placeholder="Select Hub"
                  loading={loading}
                  showSearch
                  filterOption={(input, option) =>
                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  options={filteredHubs.map((hub) => ({
                    label: hub.hubName,
                    value: hub.premiseId,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="dpType"
                label="DP Type"
                rules={[
                  {
                    required: true,
                    message: "Please select at least one DP type",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  placeholder="Select DP Type"
                  disabled
                  defaultValue={[type]}
                  options={[
                    { label: "ECOMM", value: "ECOMM" },
                    { label: "CARGO", value: "CARGO" },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item name="role" label="Role">
                <Input disabled defaultValue="ROLE_DPOPERATOR" />
              </Form.Item>
            </Col>
          </Row>

          <Row justify="end" gutter={16}>
            <Col>
              <Button
                onClick={() => {
                  setShowCreateModal(false);
                  createForm.resetFields();
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col>
              <Button type="primary" htmlType="submit" loading={createLoading}>
                Create
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default DeliveryPartnerList;
